var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#delete_svg__a)",
  opacity: 0.3
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 5,
  fill: "#343B4C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.75 9v7.5a3 3 0 0 0 3 3h4.5a3 3 0 0 0 3-3V9m-3.75 2.25v4.5m-3-4.5v4.5m4.5-9-1.055-1.582a1.5 1.5 0 0 0-1.248-.668h-1.394a1.5 1.5 0 0 0-1.248.668L9 6.75m6 0H9m6 0h3.75M9 6.75H5.25",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "delete_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 5,
  fill: "#fff"
})))));
export default SvgDelete;